import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";
import { ConsultantuseAuth } from "../../../security/ConsultantUseAuth";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../api/Get_One_Choose_Fields_From_MongoDB";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_All_From_Array_Of_Object_IDs_From_MongoDB } from "../../../api/Get_All_From_Array_Of_Object_IDs_From_MongoDB";
import { Get_All_From_Array_Of_Object_IDs_Choose_Fields_From_MongoDB } from "../../../api/Get_All_From_Array_Of_Object_IDs_Choose_Fields_From_MongoDB";
import { Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array } from "../../../api/Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array";
import { Get_All_Non_Archived_Attendees_From_Array } from "../../../api/Get_All_Non_Archived_Attendees_From_Array";

function Stats({ screenWidth }) {
  const { logoutConsultant } = ConsultantuseAuth();

  //Get EC Data
  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);
  //Get Agency Data
  const [obj_Agency, setobj_Agency] = useState({});
  useEffect(() => {
    if (obj_EC.MetaData?.Agency_id && obj_EC.MetaData.Agency_id.length > 0) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        obj_EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          BasicInfo: 1,
        },
        setobj_Agency
      );
    }
  }, [obj_EC]);
  //Get All ECs if Admin
  const [Arr_ECs, setArr_ECs] = useState([]);
  useEffect(() => {
    if (obj_EC.MetaData?.Admin === "Yes") {
      const fetchAttendeeData = async () => {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "IP",
          "EC",
          { "MetaData.Agency_id": obj_EC.MetaData?.Agency_id },
          100,
          setArr_ECs,
          {},
          { _id: 1, BasicInfo: 1 },
          logoutConsultant
        );
      };
      fetchAttendeeData();
    }
  }, [obj_EC]);
  //Part 1, get bookings data
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    const fetchAttendeeData = async () => {
      if (obj_EC.MetaData?.Admin === "Yes") {
        let Arr_ECs_IDs = Arr_ECs.map((obj) => obj._id);
        Get_All_Non_Archived_Attendees_From_Array(
          "Registers_2025",
          "All",
          "IPInfo.EC_ID",
          Arr_ECs_IDs,
          {
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
          },
          setArr_Bookings,
          logoutConsultant
        );
      } else {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "Registers_2025",
          "All",
          {
            "IPInfo.EC_ID": localStorage.getItem("Consultant_id"),
            "MetaData.Archived": { $ne: "Yes" },
          },
          1000,
          setArr_Bookings,
          {},
          {
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
          },
          logoutConsultant
        );
      }
    };
    fetchAttendeeData();
  }, [obj_EC, Arr_ECs]);

  //part 2, get all id's from bookings
  const getCompiledArray = async () => {
    // Wait for the state to update
    return new Promise((resolve) => {
      setTimeout(() => {
        let Arr_Bookingid = Arr_Bookings.map((obj) => obj._id);
        resolve(Arr_Bookingid);
      }, 0);
    });
  };

  //part 3, use the id's from bookings to find all invoices
  const [Arr_Invoices, setArr_Invoices] = useState([]);
  const fetchInvoiceData = async () => {
    const compiledArray = await getCompiledArray();

    Get_All_From_MongoDB_With_Search_Prop_In_Array(
      "Invoices",
      "Xero_2025",
      "Attendees.Attendee_id",
      compiledArray,
      setArr_Invoices,
      logoutConsultant
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      // Part 1: Fetch attendee data
      //await fetchAttendeeData();
      // Part 2: Get all IDs from bookings
      const compiledArray = await getCompiledArray();
      // Part 3: Use the IDs from bookings to find all invoices
      await fetchInvoiceData(compiledArray);
    };
    fetchData();
  }, [Arr_Bookings]);

  let countSummerExperiencesNotArchived = Arr_Bookings.filter((booking) => {
    return (
      booking.MetaData?.Archived !== "Yes" &&
      booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes("summer")
    );
  });
  let countWeekendsNotArchived = Arr_Bookings.filter((booking) => {
    return (
      booking.MetaData?.Archived !== "Yes" &&
      booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes("weekend")
    );
  });

  //----------------------------------Filter and Sort

  //filter out any onvoice with Paid_Status of "Voided" or "Credited"
  let Arr_Invoices_Filtered = Arr_Invoices.filter(
    (invoice) =>
      invoice.Paid_Status !== "Voided" && invoice.Paid_Status !== "Credited"
  );

  let UnPaidInvoices = Arr_Invoices_Filtered.filter((invoice) => {
    return invoice.Paid_Status !== "Paid";
  });

  let PaidInvoices = Arr_Invoices_Filtered.filter((invoice) => {
    return invoice.Paid_Status === "Paid";
  });

  //get days until July 1st
  let today = new Date();
  let july1 = new Date(today.getFullYear(), 6, 1);
  let one_day = 1000 * 60 * 60 * 24;
  let daysUntilJuly1 = Math.ceil((july1.getTime() - today.getTime()) / one_day) < 0 ? 0 : Math.ceil((july1.getTime() - today.getTime()) / one_day);

  console.log("Arr_ECs");
  console.log(Arr_ECs);

  return (
    <div class="w3-center w3-theme-l4" id="Stats">
      <h2 style={{ marginTop: "0px", marginBottom: "0px" }}>
        {obj_EC.MetaData?.Admin === "Yes" ? (
          <>
            <br></br>
            Welcome {obj_EC.BasicInfo?.First_Name || ""}{" "}
            {obj_EC.BasicInfo?.Last_Name || ""}, Your Teams 2025 Stats at{" "}
            {obj_Agency.BasicInfo?.Name || ""}
            <br></br>
            <p>{Arr_ECs.map((obj) => obj.BasicInfo?.First_Name + ", ")}</p>
          </>
        ) : (
          <>
            <br></br>
            Welcome {obj_EC.BasicInfo?.First_Name || ""}{" "}
            {obj_EC.BasicInfo?.Last_Name || ""}, Your 2025 Stats
          </>
        )}
      </h2>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          justifyContent: "space-between",
          marginLeft: "10%",
          marginRight: "10%",
        }}
      >
        <div
          style={{
            width: screenWidth === "Small" ? "49%" : "19.9%",
            marginBottom: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "100px",
              fontWeight: "900",
              marginBottom: "0px",
              marginTop: "0px",
            }}
          >
            {countSummerExperiencesNotArchived.length}
          </h1>
          <p style={{ marginTop: "0px" }}>
            <i>Summer Experiences</i>
          </p>
        </div>
        <div
          style={{
            width: screenWidth === "Small" ? "49%" : "19.9%",
            marginBottom: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "100px",
              fontWeight: "900",
              marginBottom: "0px",
              marginTop: "0px",
            }}
          >
            {countWeekendsNotArchived.length}
          </h1>
          <p style={{ marginTop: "0px" }}>
            <i>Weekends</i>
          </p>
        </div>
        <div
          style={{
            width: screenWidth === "Small" ? "49%" : "19.9%",
            marginBottom: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "100px",
              fontWeight: "900",
              marginBottom: "0px",
              marginTop: "0px",
            }}
          >
            {UnPaidInvoices.length}
          </h1>
          <p style={{ marginTop: "0px" }}>
            <i>UnPaid Invoices</i>
          </p>
        </div>
        <div
          style={{
            width: screenWidth === "Small" ? "49%" : "19.9%",
            marginBottom: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "100px",
              fontWeight: "900",
              marginBottom: "0px",
              marginTop: "0px",
            }}
          >
            {PaidInvoices.length}
          </h1>
          <p style={{ marginTop: "0px" }}>
            <i>Paid Invoices</i>
          </p>
        </div>
        <div
          style={{
            width: screenWidth === "Small" ? "49%" : "19.9%",
            marginBottom: "20px",
          }}
        >
          <h1
            style={{
              fontSize: "100px",
              fontWeight: "900",
              marginBottom: "0px",
              marginTop: "0px",
            }}
          >
            <i>{daysUntilJuly1}</i>
          </h1>
          <p style={{ marginTop: "0px" }}>
            <i>Days Left Until Summer...</i>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Stats;
